import {ShareType} from 'core/_types/base';
import {RootState} from 'store/store';

export const selectorGetShares = (store: RootState): Array<ShareType> => store.sharesRedux.shares;

export const selectorGetLoading = (store: RootState): boolean => store.sharesRedux.loading;
